<template lang="html">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Categories</h4>
            <div class="template-demo">
                <table class="table mb-0">
                    <tbody>
                        <tr>
                            <td class="pl-0 active">
                                <a>All</a>
                            </td>
                            <td class="pr-0 text-right">
                                <b-badge pill variant="outline-primary">
                                    {{ itemsCount }}
                                </b-badge>
                            </td>
                        </tr>
                        <tr v-for="c in categories">
                            <td class="pl-0">
                                <a>{{ c.name }}</a>
                            </td>
                            <td class="pr-0 text-right">
                                <b-badge pill variant="outline-primary">
                                    {{ itemsCountByCategory(c.name) }}
                                </b-badge>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-primary btn-block"
                        @click="handleBtnNew">
                  <i class="mdi mdi-plus"></i>Add Category
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { mapState, mapGetters } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
export default{
    name: 'categorieslist',
    extends: RestaurantChangedBase,
    computed: {
        ...mapState({
            categories: state => state.categories.categories
        }),
        ...mapGetters({
            itemsCountByCategory : 'items/itemsCountByCategory',
            itemsCount : 'items/itemsCount' 
        })
    },
    methods: {
        handleBtnNew() {
            this.$router.push( { name: 'categoryaddform' });
        },
    },
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        this.$store.dispatch('categories/getCategoriesAction');
        this.setAction('categories/getCategoriesAction');
    }
}
</script>

<style lang="scss">
   .table-longdescription {
       max-width: 230px;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis
   }

   .table-button {
       max-width: 50px;
   }
</style>